export default "__VITE_PUBLIC_ASSET__75e84945__"